import Model from "@/models/Model";
import DateFormatter from "@/utils/DateFormatter";

export default class NotificationChain extends Model {

  // DIRECTION: "IN"
  // get direction() {
  //   return this.direction;
  // }

  // FRAN: 1966
  get fromId() {
    return this.fran;
  }

  // FRAN2: null
  get parentFromId() {
    return this.fran2;
  }

  // FR_MAIL: "lars@migotto.eu"
  get fromEmail() {
    return this.fr_mail;
  }

  // FR_MAIL2: null
  get parentFromEmail() {
    return this.fr_mail2;
  }

  // HEAD: "bara till 347"
  get messageHead() {
    return this.head;
  }

  set messageHead(v) {
    this.HEAD = v;
  }

  // HEAD2: null
  get parentMessageHead() {
    return this.head2;
  }

  // LASSTATUS: null {1 id for marked as read}
  get isRead() {
    return Boolean(this.lasstatus);
  }

  get isUnread() {
    return !this.isRead;
  }

  set isRead(v) {
    this.lasstatus = Number(Boolean(v));
  }

  // LAST: null
  get readDatetime() {
    return this.last ? DateFormatter.numericToISO(this.last) : null;
  }

  // LAS_MAIL: null {email of those who read the message}
  get readerEmail() {
    return this.las_mail;
  }

  // MESSAGE: "idag serveras pannkakor till kvällsmat"
  get messageText() {
    return this.message;
  }

  set messageText(v) {
    this.message = v;
  }

  // MESSAGE2: null
  get parentMessageText() {
    return this.message2;
  }

  // MID: 310
  get messageId() {
    return this.mid;
  }

  get id() {
    return this.messageId;
  }

  // PARENTID2: null
  get grandParentMessageId() {
    return this.parentid2;
  }

  // PID: null
  get parentMessageId() {
    return this.pid;
  }

  // SENT: "2020-09-27-16.46.56.092721"
  get sentDatetime() {
    return this.sent ? new Date(this.sent) : null;
  }

  // SENT2: null
  get parentSentDatetime() {
    return this.sent2 ? new Date(this.sent2) : null;

  }

  // TBOL: 0 {0 is for Everyone}
  get receiverId() {
    return this.tbol;
  }

  // TBOL2: null
  get parentReceiverId() {
    return this.tbol2;
  }

}